/* this file is transformed by vux-loader */
/* eslint-disable */
import _createForOfIteratorHelper from "F:/zhaoyanning/\u627F\u5FB7\u5E02\u653F\u5E9C-\u5BF9\u63A5\u94F6\u884C/mobile-master/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _typeof from "F:/zhaoyanning/\u627F\u5FB7\u5E02\u653F\u5E9C-\u5BF9\u63A5\u94F6\u884C/mobile-master/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _asyncToGenerator from "F:/zhaoyanning/\u627F\u5FB7\u5E02\u653F\u5E9C-\u5BF9\u63A5\u94F6\u884C/mobile-master/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Flexbox from 'vux/src/components/flexbox/flexbox';
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item';
import Icon from 'vux/src/components/icon';
import XButton from 'vux/src/components/x-button';
import XDialog from 'vux/src/components/x-dialog';
import CryptoJS from 'crypto-js';
import commonFaile from '@/components/commonFaile';
import commonSuccess from '@/components/commonKaoqin';
import commonKaoqinPosition from '@/components/commonKaoqin/common_kaoqin_position';
import commonDel from '@/components/commonDel';
export default {
  name: 'StartWork',
  interval: '',
  components: {
    Flexbox: Flexbox,
    FlexboxItem: FlexboxItem,
    XDialog: XDialog,
    XButton: XButton,
    Icon: Icon,
    commonFaile: commonFaile,
    commonSuccess: commonSuccess,
    commonKaoqinPosition: commonKaoqinPosition,
    commonDel: commonDel
  },
  data: function data() {
    return {
      showToast: false,
      currDate: '',
      weekcn: '',
      address: '定位中...',
      tip: '',
      control: '-1',
      points: [],
      signx: '',
      signy: '',
      range: '',
      userSerial: '',
      img_src: '',
      date: [{
        worktype: ''
      }],
      workData: [{
        time: '',
        status: 1,
        oktime: []
      }, {
        time: '',
        status: 0,
        oktime: []
      }],
      ifstart: [false, false],
      limitNum: 1,
      sourceType: ['camera'],
      imgList: [],
      attenceDetail: {},
      isChecked: false,
      //是否开启定位考勤
      show: false,
      msg: '考勤打卡成功!',
      time: '17:17:17',
      locationId: '',
      userImage: '',
      sj: '',
      //时间考勤
      currentIndex: 0,
      isError: false,
      //错误显示与否
      errorMsg: '当前照片与考勤人员不符，请重新核验',
      //错误信息
      errorTitle: '考勤打卡失败',
      //错误title
      btn: '重新核验',
      isShow: false,
      isKaoqin: false,
      currentTime: null,
      isDel: false,
      comfirmMsg: '请确认是否进行下班打卡?',
      ctn: '上班打卡最多3次',
      comfirmTitle: '确认信息',
      btnMsg: '确认打卡',
      setTimeer: null
    };
  },
  watch: {
    show: {
      handler: function handler(newShow) {
        var _this = this;

        if (newShow) {
          setTimeout(function () {
            _this.show = false;
          }, 2000);
        }
      },
      deep: true
    },
    isShow: {
      handler: function handler(newShow) {
        var _this2 = this;

        if (newShow) {
          setTimeout(function () {
            _this2.isShow = false;

            _this2.$utils.Store.setItem('locationTime', null);
          }, 2000);
        }
      },
      deep: true,
      immediate: true
    },
    isKaoqin: {
      handler: function handler(isKaoqin) {
        var _this3 = this;

        if (isKaoqin) {
          setTimeout(function () {
            _this3.isKaoqin = false;
          }, 2000);
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    Attendances: function Attendances() {
      this.$router.replace({
        path: '/Attendances'
      });
    },
    //弹窗的取消功能
    closeDialogFail: function closeDialogFail() {
      this.isError = false;
    },
    //重新核验
    repeatClick: function repeatClick() {
      if (this.isChecked) {
        //this.currentIndex 下标决定
        this.$router.push({
          name: '打开拍照',
          query: {
            id: this.currentIndex
          }
        });
      } else {
        this.showRecord(this.currentIndex);
      }
    },
    //考勤打卡弹窗
    closeDialgMsg: function closeDialgMsg() {},
    //确认打卡
    comfirmBtn: function comfirmBtn() {
      this.isDel = false;

      if (this.isChecked) {
        /*打开拍照组件名字 commonTakePhoto */
        this.$router.push({
          name: '打开拍照',
          query: {
            id: this.currentIndex
          }
        });
      } else {
        this.showRecord(this.currentIndex);
      }
    },
    showDetail: function showDetail(bh) {
      var _this4 = this;

      if (this.$params.attence !== '1') {
        return;
      }

      this.showToast = true;
      this.$api.Attence.getKqDetail({
        bh: bh
      }).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        _this4.$utils.Tools.loadHide();

        if (+code !== _this4.$code.success) {
          _this4.$utils.Tools.toastShow(msg);
        } else {
          _this4.attenceDetail = data;
        }
      });
    },
    showOther: function showOther(val) {
      var _this5 = this;

      this.$api.Attence.getKqDetail({
        recordType: val,
        sj: this.attenceDetail.sj,
        fx: this.attenceDetail.fx,
        userSerial: this.userSerial
      }).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        _this5.$utils.Tools.loadHide();

        if (+code !== _this5.$code.success) {
          _this5.$utils.Tools.toastShow(msg);
        } else {
          _this5.attenceDetail = data;
        }
      });
    },
    jumpMapBig: function jumpMapBig() {
      this.$router.push({
        name: 'BdMap',
        params: {
          mapcontrol: 20,
          flag: false
        }
      });
    },
    getSysDate: function getSysDate() {
      var _this6 = this;

      this.$api.Sys.getSystemDate(this.$params.mode).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        var time = _this6.$utils.Store.getItem('locationTime');

        if (time) {
          _this6.sj = response.data.sysDate;

          _this6.$utils.Store.setItem('locationTime', _this6.sj);
        } else {
          _this6.sj = time;
        }

        if (!_this6.sj) {
          _this6.sj = response.data.sysDate;

          _this6.$utils.Store.setItem('locationTime', _this6.sj);
        }

        _this6.time = _this6.sj.split(' ')[1];

        if (+code !== _this6.$code.success) {
          _this6.$utils.Tools.toastShow(msg);
        } else {
          _this6.currDate = data.sysDate;
          _this6.weekcn = _this6.$utils.DateUtils.getWeekCnThree(data.sysDate);

          _this6.getToday();
        }
      }).catch(function () {
        _this6.$utils.Tools.httpError();
      });
    },
    getRange: function () {
      var _getRange = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, code, msg, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                this.$utils.Tools.loadShow();
                _context.next = 4;
                return this.$api.Attence.getRange({
                  userSerial: this.userSerial
                });

              case 4:
                response = _context.sent;
                code = response.code, msg = response.msg, data = response.data;
                this.$utils.Tools.loadHide();

                if (+code !== this.$code.success) {
                  this.$utils.Tools.toastShow(msg);
                  this.tip = '请先在SCM电脑端设置考勤地点及范围';
                  this.control = '0';
                } else {
                  if (data.length === 0) {
                    this.tip = '请先在SCM电脑端设置考勤地点及范围';
                    this.control = '0';
                  } else {
                    this.points = data;
                  }
                }

                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                this.$utils.Tools.httpError();

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 10]]);
      }));

      function getRange() {
        return _getRange.apply(this, arguments);
      }

      return getRange;
    }(),
    setDtConfig: function setDtConfig() {
      var _this7 = this;

      var localUrl = window.location.href.split('#')[0];
      this.$api.DingTalk.getDtConfig(localUrl).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this7.$code.success) {
          _this7.$utils.Tools.toastShow(msg);
        } else {
          _this7.$utils.DingTalk.getConfig(data);

          setTimeout(function () {
            _this7.onDtPosition();
          }, 500);
        }
      }).catch(function () {
        _this7.$utils.Tools.httpError();
      });
    },
    onDtPosition: function onDtPosition() {
      var _this8 = this;

      this.$utils.Tools.loadShow();
      var that = this;
      that.$utils.DingTalk.dtGetLocation('allmap', 14, false, function (resp) {
        _this8.$utils.Tools.loadHide();

        if (resp.flag === true) {
          that.address = resp.address;
          that.control = '0';
          that.$utils.Store.setItem('address', resp.address);
          var range = that.$utils.Position.isRange('allmap', resp.longitude, resp.latitude, that.points);

          if (_typeof(range) != Boolean && range.isTrue) {
            that.signx = resp.longitude;
            that.signy = resp.latitude;
            _this8.locationId = range.locationId;
            that.tip = '可打卡';
            that.control = '1';
          } else {
            that.tip = '';
            that.control = '2';
            _this8.isKaoqin = true;
          }
        } else {
          that.$utils.Tools.loadHide();
          that.$utils.Tools.toastShow(_this8.$t('location.failed'));
        }
      });
      that.setTimeer = setTimeout(function () {
        if (!_this8.$utils.Store.getItem('address') && !_this8.$utils.Store.getItem('resp')) {
          _this8.$utils.Tools.loadHide();

          _this8.$utils.Tools.toastShow('获取定位失败，请检查手机GPS是否开启');

          _this8.address = '';
          _this8.control = '1';
          _this8.tip = '获取定位超时';
        }
      }, 10000);
    },
    setConfig: function setConfig() {
      var _this9 = this;

      var localUrl = window.location.href.split('#')[0];
      this.$api.Sys.getConfig(localUrl, this.$params.mode).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this9.$code.success) {
          _this9.$utils.Tools.toastShow(msg);
        } else {
          _this9.$utils.WeiXin.wxConfig(data);

          setTimeout(function () {
            _this9.onPosition();
          }, 500);
        }
      }).catch(function () {
        _this9.$utils.Tools.httpError();
      });
    },
    onPosition: function onPosition() {
      var _this10 = this;

      this.$utils.Tools.loadShow('正在定位');
      var that = this;
      that.$utils.WeiXin.wxGetLocation('allmap', 14, false, function (resp) {
        _this10.$utils.Tools.loadHide();

        if (resp.flag === true) {
          that.address = resp.address;
          that.control = '0';
          that.$utils.Store.setItem('address', resp.address);
          that.$utils.Store.setItem('resp', JSON.stringify(resp));
          var range = that.$utils.Position.isRange('allmap', resp.longitude, resp.latitude, that.points);

          if (_typeof(range) != Boolean && range.isTrue) {
            that.signx = resp.longitude;
            that.signy = resp.latitude;
            that.locationId = range.locationId;
            that.tip = '可打卡';
            that.control = '1'; //当前图片

            that.currentImg();
          } else {
            that.tip = '';
            that.control = '2';
          }
        } else {
          that.$utils.Tools.loadHide();
          that.$utils.Tools.toastShow(_this10.$t('location.failed'));
        }
      });
      that.setTimeer = setTimeout(function () {
        if (!_this10.$utils.Store.getItem('address') && !_this10.$utils.Store.getItem('resp')) {
          _this10.$utils.Tools.loadHide();

          _this10.$utils.Tools.toastShow('获取定位失败，请检查手机GPS是否开启');

          _this10.address = '';
          _this10.control = '1';
          _this10.tip = '获取定位超时';
        }
      }, 10000);
    },
    dkclick: function dkclick(item, index) {
      var _this11 = this;

      if (this.control !== '1') {
        this.isKaoqin = true;
        this.ctn = '未在考勤范围内，无法打卡';
      } else {
        this.index = index;
        this.$api.Sys.getSystemDate(this.$params.mode).then(function (response) {
          var code = response.code,
              msg = response.msg;

          if (+code !== _this11.$code.success) {
            _this11.$utils.Tools.toastShow(msg);
          } else {
            _this11.showMsg(index);
          }
        }).catch(function () {
          _this11.$utils.Tools.httpError();
        });
      }
    },
    showMsg: function showMsg(index) {
      this.currentIndex = index;

      if (this.ifstart[this.currentIndex]) {
        this.isDel = true;
        this.comfirmMsg = this.currentIndex == 0 ? '已有上班打卡记录，是否再次打卡?' : '已有下班打卡记录，是否再次打卡?';
      } else {
        if (this.currentIndex == 1) {
          this.isDel = true;
          this.comfirmMsg = '是否确定下班打卡?';
        } else {
          this.comfirmBtn();
        } // this.comfirmMsg = this.currentIndex==1?'是否确定下班打卡?':'是否确定上班打卡?';

      }
    },
    showRecord: function showRecord(index, currDate, image) {
      var _this12 = this;

      this.$utils.Tools.loadShow();
      var params = {
        fx: index === 0 ? 1 : 2,
        lname: this.$utils.Store.getItem('userLname'),
        lx: '0',
        openId: this.$utils.Store.getItem('openId'),
        sj: this.sj,
        userNo: this.$utils.Store.getItem('userNo'),
        userSerial: this.userSerial,
        image: image,
        jing: this.signx,
        wei: this.signy,
        address: this.address,
        locationId: this.locationId,
        userImage: this.userImage
      };
      this.currentTime = params.sj;
      var key = CryptoJS.enc.Utf8.parse('weds123456789012');
      var iv = CryptoJS.enc.Utf8.parse('weds123456789012');
      var temp = CryptoJS.enc.Utf8.parse(JSON.stringify(params));
      var data = CryptoJS.AES.encrypt(temp, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }).toString();
      this.$api.Attence.insertAttenct({
        data: data
      }).then(function (response) {
        var code = response.code;

        _this12.$utils.Tools.loadHide();

        if (+code !== _this12.$code.success) {
          if (+code === 603) {
            //上班打卡最多3次
            _this12.isKaoqin = true;
          } else if (+code === 601) {
            // this.$utils.Tools.toastShow(msg)
            // this.$utils.Tools.toastCancel('添加记录失败');
            _this12.isError = true;
          }
        } else {
          _this12.ifstart[index] = true;

          _this12.getSysDate();

          _this12.isShow = true;
        }
      }).catch(function () {
        _this12.$utils.Tools.httpError();
      });
    },
    getBanci: function getBanci() {
      var _this13 = this;

      this.$api.Attence.getBanci({
        banciId: 1
      }).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this13.$code.success) {
          _this13.$utils.Tools.toastShow(msg);
        } else {
          _this13.date = data;

          for (var i = 0; i < _this13.date.length; i++) {
            for (var key in _this13.date[i]) {
              if (key !== 'workType') {
                _this13.date[i][key] = _this13.$utils.DateUtils.formatScmDate(_this13.date[i][key]);
              }
            }

            if (i === 0) {
              _this13.workData[0].time = _this13.date[i].startWork;
              _this13.workData[1].time = _this13.date[i].endWork;
            }
          }
        }
      }).catch(function () {
        _this13.$utils.Tools.httpError();
      });
    },
    getToday: function getToday() {
      var _this14 = this;

      this.workData[0].oktime = [];
      this.workData[1].oktime = [];
      0;
      this.$api.Attence.getToday({
        userSerial: this.userSerial,
        dates: this.$utils.DateUtils.getFullDate(this.currDate)
      }).then(function (response) {
        var code = response.code,
            data = response.data;

        if (+code !== _this14.$code.success) {// this.$utils.Tools.toastShow(msg)
        } else {
          for (var i = 0; i < data.length; i++) {
            var timeSource = data[i].sj;
            var fmtTime = ''; // this.$params.attence === '1'

            if (timeSource.length === 19) {
              fmtTime = _this14.$utils.DateUtils.formatDate(timeSource, 'HH:mm:ss');
            } else {
              fmtTime = _this14.$utils.DateUtils.formatScmTime(timeSource);
            }

            if (+data[i].fx === 1) {
              _this14.workData[0].oktime.push({
                time: fmtTime,
                bh: data[i].bh
              });

              _this14.ifstart[0] = true;
            } else if (+data[i].fx === 2) {
              _this14.workData[1].oktime.push({
                time: fmtTime,
                bh: data[i].bh
              });

              _this14.ifstart[1] = true;
            }
          }

          _this14.$nextTick(function () {
            var divs = document.getElementsByClassName('div-record');

            var _iterator = _createForOfIteratorHelper(divs),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var item = _step.value;
                item.scrollTop = item.scrollHeight;
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          });
        }
      }).catch(function () {
        _this14.$utils.Tools.httpError();
      });
    },
    //判断是否需要打卡
    getValue: function getValue() {
      var _this15 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this15.$api.Attence.getKqSettting().then(function (res) {
                  _this15.isChecked = res.data.dwCheck;
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    currentImg: function currentImg() {
      //判断定位是否有图片src
      var param = this.$utils.Store.get('locationId');

      if (param && param.serverId) {
        this.userImage = param.serverId;
        this.currentIndex = param.id;
        this.showRecord(param.id);
        this.$utils.Store.set('locationId', null);
      } else if (param && param.dingweidakaishib) {
        this.isError = param.dingweidakaishib && param.dingweidakaishib ? param.dingweidakaishib : true;
        this.errorMsg = param.errMsg && param.errMsg ? param.errMsg : '人脸校验失败';
        this.$utils.Store.set('locationId', null);
      }
    }
  },
  created: function created() {
    this.$utils.Store.removeItem('address');
    this.$utils.Store.removeItem('resp');
    this.userSerial = this.$utils.Store.getItem('userSerial');
    this.getSysDate();
    this.getBanci();
    this.getValue();
  },
  mounted: function mounted() {
    var _this16 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this16.getRange();

            case 2:
              _this16.$utils.Tools.getEnv(function (res) {
                if (res === 0 || res === 1) {
                  _this16.setConfig();

                  _this16.interval = setInterval(function () {
                    _this16.onPosition();
                  }, 60000);
                } else {
                  _this16.setDtConfig();

                  _this16.interval = setInterval(function () {
                    _this16.onDtPosition();
                  }, 60000);
                }
              });

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  destroyed: function destroyed() {
    clearInterval(this.interval);
    clearTimeout(this.setTimeer);
    this.$utils.Tools.loadHide();
  }
};